export const  DispatchDymoXML = `<?xml version="1.0" encoding="utf-8"?>
<DesktopLabel Version="1">
  <DYMOLabel Version="4">
    <Description>DYMO Label</Description>
    <Orientation>Landscape</Orientation>
    <LabelName>White Shipping Labels DHL</LabelName>
    <InitialLength>0</InitialLength>
    <BorderStyle>SolidLine</BorderStyle>
    <DYMORect>
      <DYMOPoint>
        <X>0.18666665</X>
        <Y>0.123333335</Y>
      </DYMOPoint>
      <Size>
        <Width>7.895834</Width>
        <Height>3.7694442</Height>
      </Size>
    </DYMORect>
    <BorderColor>
      <SolidColorBrush>
        <Color A="1" R="0" G="0" B="0"></Color>
      </SolidColorBrush>
    </BorderColor>
    <BorderThickness>3</BorderThickness>
    <Show_Border>True</Show_Border>
    <HasFixedLength>False</HasFixedLength>
    <FixedLengthValue>0</FixedLengthValue>
    <DynamicLayoutManager>
      <RotationBehavior>ClearObjects</RotationBehavior>
      <LabelObjects>
        <ImageObject>
          <Name>ImageObject0</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <Data>/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCABZAL8DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9UJpo7eF5ZXWKKNSzu5AVQBkkk9BXi+o/tqfA3S76a0uPiboPnQsUfyZzKuR1wyAqfwNebf8ABT7xTqfhn9lXUI9NupLT+1NTttPuWjOGaBt7smfQ+WAfUEjvX4wUFJXP3f8A+G4/gP8A9FN0X85P/ia9W8F+PPDnxG0OPWfC+t2Ov6XISq3WnzrKm4dVJB4YZ5B5FfzlV9P/APBPr9op/gT8cbKz1K8aHwl4kZdO1FXfEcUhOIbgjoNrHBP912oDlP1v+JH7RHw2+EGq2+meMvGOmaBqNxF58drdSHzDHkgPtUEgEggE9cH0rqvBvjXQviH4bs9f8Nara61o12CYL2zkDxvgkEZ9QQQQeQRX5I/8FXkZf2o7ZipAbw9aFSRwf3k3Su8/4JRftC/8I94s1L4U6xdbbDWS19o5kbhLpV/exD/fRdw94/VqAtpc/U2iiigkKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigD41/4Kuf8AJrcP/YwWn/ouavx2r9if+Crn/JrcP/YwWn/ouavx2oLjsFFFFBR90eOP+MyP2KdO8YR/6V8Svhav2LVgOZbvT8cSnuflUPk945vWvinwz4k1Hwf4i0zXdIuWs9U025ju7W4jPMciMGU/mK9r/Yn+PEfwI+Nthc6q6t4S1xf7J1uGUZjNvIcCRgeDsbDH/Z3jvX1l4k/4JAxap4svrzRPiJDp3hy5uWmtrOTTDLLBCzZEYcSgNtBwGwM4FBOx+ifhzUZNY8PaXfyqqy3VrFO6p0DMgYge3NaNVNI01NH0mysImZ47WBIFZupCqFBPvxVuggK4/wCIHxi8D/CtIG8YeLNI8OG45hj1G7SJ5B6qpO4j3ArsK/JH41X3gXTf+ChHjWb4/wBlqN94Q8kCxjj84qFMUX2dsRMGMYXzPu/xHkdaBn6I6b+118FtWvobO1+J3hp7iZgkatqCICx6DLED9a7vxF8RfC3hG6srbW/EWmaTcXsM1xaw3l0kbzxxJvldATlgi/MSOg5r4J0vSf2AvGUltZ2c9npd1LKmxrmbU7XBDA4Zpv3YU9DuOMGnf8FJtQj0H4zfs73WnTR2dvb3MhikhKiNYvPtRgdtm3jHTHtQB9i2f7Unwd1C5jt7f4oeEpJpDtRP7ZtwSfTlq6fxp8VPB3w4srK88U+KNJ8PWl6StrPqV5HCkxABOwsQG4IPHrXwp+1J+yn+zP4O+CPjHxD4cudP0zxHa2zT6f8AZfEDTGSfcNsSxNIwYMTjAHA6YxXzT8Xta1DW/wBhD4FvqlxLci31vVbWF5iSRAjAKoPcLyo9AMdqAsfqp/w1h8GP+ip+Ef8AwcQf/FV0Y+NPgE6fpV+PGWh/Y9WhuLnT5/t8Wy7igBM7xnPzhApLEdMHNfCeleB/2B9Sls7SPU4pb24ZIljF7quWkbAA9Opqh+3l4T0T4E+Mv2adE8Lr/YmhaLe3fkCWdnEMbXVs8m55CSVO987jjBI6UAfbcP7VfwauJUjT4peES7HAB1mAc/i1dxrXjnw74b8MnxHquu6dp/h8Kj/2pcXSJbbXIVD5hO3DFgBzzkV8I/GD9nD9jrTfhz4r1PS9f0Kx1aGwuJ7R9P8AFJnkE4QmNUh81g2WwNu09a8a8D6rqepf8EoPiHDfzTTWtl4mht7ESkkJD59k5Vc/w+Y8h+pNAH6R6t+018JdB1O607UviR4Xsb+1kMU9tcarCkkbg4KsC2Qa7Lwn428PePNLGpeGtc07X9PLbftWmXSXEe703ISAfavgf4OfB/8AZj+K3wf8F+I/iTrWgN41uNHt4dRkufE/2SYtEnlp5kYmXDBEQZIycAnNc5/wTtXS/DX7ZXxW8OeBtUm1P4fJp9y1rL5pkilEd1CsL7ujEB5AG7gk96AP0A0n42fD/XbHXrzTvGeh31poKb9Vmt7+N0sV+bmYg/IPkfr/AHT6Vr+DPHnhv4i6OdV8La7p/iHTRI0Ju9NuUnjDgAlSykjIBHHuK/K39mv/AJJH+2b/ANg1v53tcj+xB8eta/ZZ8XaHqXiFJk+GHjZnt55+TFFLFIYzOPRoyRvHUo4PJ20BY/Xa8+KHhDT/ABrbeD7nxNpUHiq5UPBosl2i3cilSwKx53EYVj06A11FfnR8RriK7/4K0fD2eCRJoZNPhdJI2DKymyuSCCOoI71+i9AHhX7bXwfu/jb+zf4q0DTYjNrFuialYRL1kmhO/YPdl3qPdhX4RFSrEMMMOCD2r+lKvxZ/4KNfs8/8KU+OVxrOmWvk+F/FZfULTYuEhuMj7RCOwwzBwP7sgHagcT5SooooLCv2c/4Jt/tC/wDC5PgjF4e1S583xN4SCWE+9svNa4P2eX3+VSh90yfvV+Mde1/se/Hif9nn46aF4ieVholy40/V4geHtZCAzY7lCFkHumO9AmfvRRTY5FkRXRg6MMhlOQR606gzCvkL40/tQfsyat8SNa8EfFTTrS71Lw9Itv8AbdV0NruLcVDMkUkaO42kkHIAyOM19e18TeOP2gPgf8RP2qJvhT8Qvhnpt1q8F3/ZkHiTVIIZUeUoGjjJ271DFgoySASPXNAz5p/a88Tfska18J7tPhTaWy+OTcQm0fTLC8tVVN483zPNVUKlN2BgnOPeqn7U3hrULz4e/sj6D4nS5iurnSfslykpxMkby2qqpz0YRlRz0xX6G6v8DfgV8E9F1HxtdeAPC+jWuiwNeSX39mxM0QQZBTI+9nAGOSSAK8S8N/tjfDb9oT4f+OfiBq/wri1A/DmCG8hTVlt7iZvNdv8AUsUPlkGIE/QelAzSt/8AglJ8EYZ45HfxNcKpyYpNTQK3sdsQOPoRXkn/AAVU8H6J8P8A4Q/CPw7oGnw6XoenX1zDb2cIO2NBGh78kkkkk8kkk8muptP+Cs2l6hbrPbfCbxJcQN92SK4RlODg4IT1q14i/bc8FfFT4Y6l4m8U/Au81620PVLWyh03VoIrh91zHOxlj3xnAAt8HjncPSgNTltL+MX7CmnSWlzH4dtYryApIsi6LeZWRcEEceorl/8AgoV4y8NfHrVP2ddb0WeW+8Ma/cXsKSPG8DvH9qtoX4YBl5Vh+tVbj9tH4EWdzFbz/st2UNxMcRxSafaKz844BhyefSvdf2dvjz8N/wBpHxtpPgk/AqLw9b6FZz32mT6lYQPBZ4kRmWFfLGwszBvlxyuaAPP/ANrL/gm34G8IfBHXPEfw2sNQh8QaKBfSQT3j3AuLZAfOUK3Rgp3gj+4R3rA174meHPiJ/wAEpdVt9DsLTR7vQ5bDTtT0+0UIq3C3kJM2Op80EPk9yw7V9P8Ahz9uLwb4s+OHiL4ctYNbabpd2ulSeIbq4X7Lc3buIkt0QAks8nmKMnBEbHpXp198Gfhr4U8HeIYbf4f+HY9JuIPtF9p8GmQJFd+TmRA6hcMVOSMg4JoEfG/wF/4J4fCv4ufsz+GfEdzbahaeK9a0dpft6X0nlx3DBgsnl9CAQDt74qv/AMEt/EWn/D3xb8QvhJ4g0e10jx7Z3bSm62Ymu44jskhLHqI2+dQOokY9s19Nfsb/ALQ3hz9oL4eX9x4W8JnwbpGh3Y06LTQ0flqNiv8AIqABR83TFeqr8K/Bq+Mj4tXwroy+KSdx1pbGMXedmzPm7d2dny9enFAXPy4/Zr/5JH+2b/2DW/ne17B+y1+z3pP7SX/BPOHwrqHl2+orqV9caXqDLk2l0sh2t67T91h3UnuBX3Dpnwe8C6LZ61aaf4O0KytdbXZqcNvp8SJer83EwC/OPnb72fvH1rX8K+D9C8DaQmleHdHsdC0xGZ1s9Ot0giDMcsQqgDJNAXPx2/ZRTxXpn7dfw58O+MxOmt+G5Z9FaO45eOOG2uNiZ/iUBsKem3bjjFftDXMz/DHwhdeMYvFs3hfSJfFEWNmstZRm7XC7BiXbu+6SvXpxXTUAcv8AEn4meGfhD4Ru/E/i7VY9G0S1KrJdSI7/ADMwVVCoCzEk9ADXy18bvGHwn/b++FHiPwR4C8TW+teNNLtzrOlQyWs9vIJY+ML5sa7lcMYzjON4J6Vtf8FQbWa4/ZL1hoomkWHUrKSQqM7F83bk+gywH4ivyX+CPxY1T4H/ABU8O+NdJJa40u5EksAOBcQn5ZYj7MhYe2Qe1A0jip4JbWaSGaNopo2KPG4IZWBwQR2INMr6w/4KCfCfTNH8caP8VPCAWbwP8Q7capbyxLhYrplDSoQOhbcHx6lx/DXyfQWFIaWigD+iX4Q3El18JvBU0rF5ZNEsndj1JMCEmuurjvgz/wAkf8C/9gKx/wDSdK7GgyCvxz+L3wR1L49/ttfGvQdDmaLX7GCfVdORTjzp4Rb4jz2LKzAHsxXtX7GV8O/Bz4O+NdC/4KM/EXxvqHhq+tfCd/aXKWuryJiCVm+z7Qpz32N+RoGj50f41fEj9vKz+HfwLW3uNLubImTxdqjj/XCB9omkXttUAlT96VgOMCsH9nGwj0n9m39rayh3GG2tLSFNxydqzXAGffAr9cdI8E+HfD+rX2qaXoOmabqd+S13e2dnHFNcEncTI6qGck88k81+bvwa/Z1+JWg/Bb9p7S9Q8Gapaaj4iigGk28kQD3pE05Pl884DKfxoHcyP2U/2vPil8K/gX4f8NeGvgXrPjPR7N7kw61aJcmOffPI7AbIGX5WYrwx+7X6QfBvxrq/xF+GWgeI9e8Pz+FdX1CEyXGj3IcSWrB2Xa29VboAeQOtfn/8BfiL+1L8AfhbpHgfSfgS2pWGmtM0dzewy+a3mSvKc7ZAOC5HTtX17+y58U/iz8TIfEjfFL4fR+A3s2txp6xpIv2oOJPMPzs33dqdMfeoEz5m/bm/5Ps/Z2/6+rD/ANONfV37Wnxqj+AfwF8T+KkkVNUEP2PS1PVruXKxkeu3lyPRDXgX7Xnwf8aeNv2wfgd4l0Hw3fapoOj3Fm2oahbpmK2C329i5zxhefpVD9ur4V/Eb9pD41fD3wHpXh3U4/h5Yzxz6nrix4txJK2JHznny4QQP9qRhQM+Lde8N+EfCf7JunTT+Lls/i7d61B4mfSD5vnSWjoUtyW27d4V/PUls7ZW9a/Uv4J/GaH49fsqweLg6tqE2j3FvqMa/wDLO7jiZJRjtkjcPZ1rf1n9lf4ReIBIdQ+HXh67nkgW3NzLYRtNsWMRp85G7KqqgHPGBXyn+xv8J/id8AfE3xc+GureGtUn8FahDdS6PrPl5t5J0VkQg5486Ir26xqKBFn/AII/f8kb8b/9h5f/AEnjr74r8pv2X7r9pv8AZa8K6voehfBG41eDUr37bJJqMMgZW2KmBscDGFr7S/Zg+L3xm+JWta5b/FD4ax+BbK1t45LKdEkX7RIWIZfmdugwePWgGfQ9FFFAgooooAwvHXgvS/iN4N1nwxrcAudK1a1ktLiPvtYYyPRhwQexANfz+fGT4Xap8Fvid4h8F6wp+2aTdNCJdpAniPMcq+zoVYfWv6IK+Yf2rP2D/DP7UfiTSvENxrdz4Z1qztzaTXFrbJMLqIEsgcEjlSWwc9DjsKCkz5q/ZC+Gc/7UX7A/jTwDqMwludJ1qY+Hppv+XScQxzIoPZS8kin2lavzo1LTbrR9RutPvoHtb21laCeCUYaORSVZSOxBBH4V+8f7K/7Mul/ss+Ab7w1pusXWum+v31Ce7uoliO4oiBVVScALGO55J+leWftEf8E2/Afx28aXXiy01e+8Ia3fNvvzZxJNBcv3kMbY2ue5DYPUjOSQLn4zUhr9Qv8AhzroH/RTNS/8FUf/AMcrqfhr/wAEmvAPg/xZZav4g8Tal4ttLSRZl0uS2S2hlYHIEuCxZfVQRnvxxQVzI+uvg7G8Pwj8ERyKUkTQ7FWVhggi3TINdfSKoRQqgKoGAAOBS0GYVy1z8QLS0/tSaSwvRp2mmYXN+vlGNTGu5hsEnmew+Tk+xBPU1xPiD4bjxLqstzdXFnHEwmTzLewCXZWS3eHY0287lAkJA2dVT+7yAba+NtCa6it/7VtknlQOscj7TgqWGc9DtUnB5wCahX4g+G5EiYazabZG2qTJj+5z7D94nJ4+dfWsLW/hre+IbW9trzWoRBfSLcXIhsirGdYBEGQmQ7U+WM7SCchvm54ueLPh2nifVLO8N2sSx2zWc0MiOyyxl1Y4CyIM4Uj5gw+b7vYgGzrHiqx0PWNJ067MiS6kzrFIFHloVA++2flyWVR6swHes3RPid4e1yxtbpL5bVLqWSOBLohGkCzGJXAycK7AbScZ3DgHipdU8FxeKobQeIBBeAWcttc28KMkUhkaJtynduXaYhg5znnIxWXP8MmLXsdvqSwWd+wF1CbXc2wXMk6rGQ4CH966kkN/CQBjkA2ZPiD4bjWRm1q0AjbY37zPPz9PUfu35HHyN6VvRSpPGkkbrJG4DK6nIYHoQe4rjNV+G/27Q/D9jBqHkz6PD5KTOkm2RTFsOVjkRgeAfvY46HqOp0fTzpWmwWYMZit1EUQij2BY1GFXGTyAAM8fQdKALtFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAH/2Q==</Data>
          <ScaleMode>Uniform</ScaleMode>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.47706088</X>
              <Y>0.39950627</Y>
            </DYMOPoint>
            <Size>
              <Width>1.2620547</Width>
              <Height>0.551391</Height>
            </Size>
          </ObjectLayout>
        </ImageObject>
        <ShapeObject>
          <Name>ShapeObject0</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <StrokeWidth>1</StrokeWidth>
          <DashPattern>SolidLine</DashPattern>
          <ShapeType>Rectangle</ShapeType>
          <ObjectLayout>
            <DYMOPoint>
              <X>4.4559627</X>
              <Y>2.5096223</Y>
            </DYMOPoint>
            <Size>
              <Width>3.3012264</Width>
              <Height>1.143844</Height>
            </Size>
          </ObjectLayout>
        </ShapeObject>
        <TextObject>
          <Name>TextObject13</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Right</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Right</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>{{DEPARTMENT}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>23</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>4.870981</X>
              <Y>0.43075702</Y>
            </DYMOPoint>
            <Size>
              <Width>2.9030871</Width>
              <Height>0.48888955</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject2</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Center</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>13.01</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>77.4</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>4.53141</X>
              <Y>2.5765939</Y>
            </DYMOPoint>
            <Size>
              <Width>3.155051</Width>
              <Height>1.0768719</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject3</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Center</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>WEEKLY PLAN NUMBER</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>13.3</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>4.75439</X>
              <Y>2.2914872</Y>
            </DYMOPoint>
            <Size>
              <Width>2.7043724</Width>
              <Height>0.18794712</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject5</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>CUSTOMER - </Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>13.9</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
              <TextSpan>
                <Text>{{CUSTOMER_NAME}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>13.9</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.47706088</X>
              <Y>0.9423002</Y>
            </DYMOPoint>
            <Size>
              <Width>3.5478387</Width>
              <Height>0.2643233</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject8</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Right</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Right</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>PACKED BY - </Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>13.5</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
              <TextSpan>
                <Text>{{PACKED_BY}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>13.5</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>4.2852592</X>
              <Y>0.9258703</Y>
            </DYMOPoint>
            <Size>
              <Width>3.488809</Width>
              <Height>0.29718316</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject11</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>None</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>None</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>PRODUCT - {{PRODUCT_NAME_LINE_1}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
            <LineTextSpan>
              <TextSpan>
                <Text>PRODUCT - {{PRODUCT_NAME_LINE_2}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
            <LineTextSpan>
              <TextSpan>
                <Text>PRODUCT - {{PRODUCT_NAME_LINE_3}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.47706088</X>
              <Y>1.2877941</Y>
            </DYMOPoint>
            <Size>
              <Width>7.0486326</Width>
              <Height>0.79160535</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject12</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>DATE - </Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>17.4</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
              <TextSpan>
                <Text>{{DATE}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>17.4</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.47706088</X>
              <Y>2.7388225</Y>
            </DYMOPoint>
            <Size>
              <Width>3.5646358</Width>
              <Height>0.24251494</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject1214</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>None</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>None</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>BOX OF -</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.47706088</X>
              <Y>3.1650734</Y>
            </DYMOPoint>
            <Size>
              <Width>1.03624</Width>
              <Height>0.22436993</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject151617</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Top</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>DELIVERY</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16.2</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.8847941</X>
              <Y>2.2519073</Y>
            </DYMOPoint>
            <Size>
              <Width>1.3294843</Width>
              <Height>0.22762565</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <TextObject>
          <Name>TextObject17</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Top</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>COLLECTION</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16.6</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>2.6327357</X>
              <Y>2.2339046</Y>
            </DYMOPoint>
            <Size>
              <Width>1.6357603</Width>
              <Height>0.2365747</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
        <ShapeObject>
          <Name>ShapeObject1</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                {{FILL_DELIVERY}}
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <StrokeWidth>1</StrokeWidth>
          <DashPattern>SolidLine</DashPattern>
          <ShapeType>Ellipse</ShapeType>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.47706088</X>
              <Y>2.1728663</Y>
            </DYMOPoint>
            <Size>
              <Width>0.3492523</Width>
              <Height>0.35865116</Height>
            </Size>
          </ObjectLayout>
        </ShapeObject>
        <ShapeObject>
          <Name>ShapeObject2</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
               {{FILL_COLLECTION}}
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <StrokeWidth>1</StrokeWidth>
          <DashPattern>SolidLine</DashPattern>
          <ShapeType>Ellipse</ShapeType>
          <ObjectLayout>
            <DYMOPoint>
              <X>2.2509804</X>
              <Y>2.1720614</Y>
            </DYMOPoint>
            <Size>
              <Width>0.3568612</Width>
              <Height>0.34301823</Height>
            </Size>
          </ObjectLayout>
        </ShapeObject>
        <TextObject>
          <Name>TextObject4</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Left</HorizontalAlignment>
            <VerticalAlignment>Top</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>JOB - {{JOB_NUMBER}}</Text>
                <FontInfo>
                  <FontName>Microsoft JhengHei</FontName>
                  <FontSize>16</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>1.8707042</X>
              <Y>0.5492965</Y>
            </DYMOPoint>
            <Size>
              <Width>2.7173705</Width>
              <Height>0.25181064</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
      </LabelObjects>
    </DynamicLayoutManager>
  </DYMOLabel>
  <LabelApplication>Blank</LabelApplication>
  <DataTable>
    <Columns></Columns>
    <Rows></Rows>
  </DataTable>
</DesktopLabel>`